import * as types from "./app.actionTypes";

export const setHospitalsDetails = (updates) => {
  return {
    type: types.SET_HOSPITALS_DETAILS,
    payload: updates,
  };
};

export const setGlobalSearchReset = (payload) => ({
  type: types.GLOBAL_SEARCH_RESET,
  payload: payload,
});

export const setIsBookmarkTable = (payload) => ({
  type: types.IS_BOOKMARK_TABLE,
  payload: payload,
});

export const setView = (payload) => {
  return {
    type: types.VIEW,
    payload: payload,
  };
};

export const addProviderNumbers = (providerNumbers) => ({
  type: types.ADD_PROVIDER_NUMBERS,
  payload: providerNumbers,
});

export const clearProviderNumbers = () => ({
  type: types.CLEAR_PROVIDER_NUMBERS,
});

export const triggerDataRefetch = () => ({
  type: types.TRIGGER_DATA_REFETCH,
  payload: Date.now(),
});

// Transient flag that keeps the table skeleton visible while filters are being
// reset and the "all hospitals" data is re-fetched, preventing the empty-state
// ("No data") SVG from flashing in between.
export const setTableResetting = (payload) => ({
  type: types.SET_TABLE_RESETTING,
  payload,
});

// Restores a previously captured snapshot of app + hospital slice state.
// The same action is handled by both the app and hospital reducers.
export const restoreStateSnapshot = (snapshot) => ({
  type: types.RESTORE_STATE_SNAPSHOT,
  payload: snapshot,
});